var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "searchbar",
      on: {
        keyup: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
        submit: function ($event) {
          $event.preventDefault()
          return _vm.falseSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c("img", {
        staticClass: "search-icon svg",
        attrs: {
          src: "/app/themes/ucla/resources/assets/images/search.svg",
          width: "16px",
          height: "16px",
          alt: "Search Research",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "sr-only" }, [_vm._v("Research Search")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.newSearch,
            expression: "newSearch",
          },
        ],
        attrs: {
          type: "text",
          placeholder: "Search...",
          "aria-labelledby": "Search Research",
        },
        domProps: { value: _vm.newSearch },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.newSearch = $event.target.value
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/ResearchSearch.vue